import Bugsnag from "@bugsnag/js";
import { CAN_CACHE_IMAGES, SITE_NAME } from "@constants";
import NextImage, { ImageProps } from "next/image";
import React, { FC } from "react";

type IProps = {
  activeCache: boolean;
  fallback?: string;
} & Omit<ImageProps, "alt"> & { alt?: string };

export const Image: FC<IProps> = ({
  activeCache,
  alt = SITE_NAME,
  ...props
}) => {
  if (!props.src) {
    return null;
  }

  return (
    <NextImage
      {...props}
      alt={alt}
      src={props.src}
      onError={(e) => {
        Bugsnag.notify(
          new Error(`Error loading image :${props.src}, error: ${e}`)
        );
        // If no error is set, then we need to set the error. Else this will cause continuos rendering in infinity loop
      }}
      unoptimized={CAN_CACHE_IMAGES ? !activeCache : true}
      style={{
        maxWidth: "100%",
      }}
    />
  );
};
